import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

const SkeletonGridLoader = () => {
  return (
    <Box style={{marginTop: 30}}>
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton animation="wave" />
      <Skeleton/>
    </Box>
  );
}


export default SkeletonGridLoader;
